const EntityStatus = {
  Preview: "Preview",
  Active: "Active",
  Inactive: "Inactive",
  Intake: "Intake",
};

export default EntityStatus;
